import type { App as VueApp, Plugin } from "vue";

import ModuleDeviceTelemetry from "@DataWeb/Scripts/Components/Modules/ModuleDeviceTelemetry.vue";

const DataWebConfig: Plugin = {
    install(app: VueApp) {
        app.component("app-moduledevicetelemetry", ModuleDeviceTelemetry);
    }
};

export default DataWebConfig;